import { projectsData } from "../data/projects.generated";

export interface Project {
  id: string;
  title: string;
  subtitle: string;
  year: number;
  tags: string[];
  category: string;
  featured: boolean;
  brief?: string;
  image?: string;
  bodyHtml: string;
}

export const FEATURED_PROJECT_IDS = [
  "aurora-forecaster",
  "uc-aerospace-rocket",
  "metroinfo-ha",
] as const;

const allProjects = projectsData as Project[];
const featuredProjectIdSet = new Set<string>(FEATURED_PROJECT_IDS);

/** Get all projects, sorted by year descending */
export function loadProjects(): Project[] {
  return [...allProjects];
}

export function loadFeaturedProjects(): Project[] {
  return FEATURED_PROJECT_IDS
    .map((id) => allProjects.find((project) => project.id === id))
    .filter((project): project is Project => Boolean(project));
}

export function loadOtherProjects(): Project[] {
  return allProjects.filter((project) => !featuredProjectIdSet.has(project.id));
}

/** Get a single project by ID */
export function loadProject(id: string): Project | null {
  return allProjects.find((p) => p.id === id) ?? null;
}
